export default "__VITE_ASSET__40bb9ef5__"